<template>
  <svg
    class="tool-svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <g v-if="id === 'background-remover'">
      <path d="M4 5.5h16v13H4z"/><path d="m4 15 4.2-4 3.1 2.8 2.4-2.1 3.2 3"/><circle cx="15.8" cy="8.5" r="1.4"/><path d="M17.5 17.5 21 21M21 17.5 17.5 21"/>
    </g>
    <g v-else-if="id === 'image-compressor'">
      <path d="M8 3v5H3M16 3v5h5M8 21v-5H3M16 21v-5h5"/><path d="m3 8 5-5M21 8l-5-5M3 16l5 5M21 16l-5 5"/>
    </g>
    <g v-else-if="id === 'flip-image'">
      <path d="M12 3v18"/><path d="m9 7-5 5 5 5V7ZM15 7l5 5-5 5V7Z"/>
    </g>
    <g v-else-if="id === 'rotate-image'">
      <path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 5v6h-6"/>
    </g>
    <g v-else-if="id === 'black-white-image'">
      <circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 0 0 17Z"/><path d="M12 7v10"/>
    </g>
    <g v-else-if="id === 'pixelate-image'">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </g>
    <g v-else-if="id === 'round-image'">
      <circle cx="12" cy="12" r="8"/><path d="m7 15 3-3 2.5 2.5 2-2L17 15"/><circle cx="15.5" cy="8.5" r="1"/>
    </g>
    <g v-else-if="id === 'border-image'">
      <rect x="3" y="3" width="18" height="18" rx="2"/><rect x="7" y="7" width="10" height="10" rx="1"/><path d="m8.5 15 2.5-3 2 2 1.5-1.5 1.5 2"/>
    </g>
    <g v-else-if="id === 'text-image'">
      <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M8 9h8M12 9v7M9.5 16h5"/>
    </g>
    <g v-else-if="id === 'crop-image'">
      <path d="M7 3v14a2 2 0 0 0 2 2h12M3 7h14a2 2 0 0 1 2 2v12"/>
    </g>
    <g v-else-if="id === 'watermark-image'">
      <rect x="3" y="4" width="18" height="16" rx="2"/><path d="m5 17 5-5 3 3 2-2 4 4"/><path d="M8 8h8M10 6v4M14 6v4"/>
    </g>
    <g v-else-if="id === 'combine-images'">
      <rect x="3" y="5" width="8" height="14" rx="1"/><rect x="13" y="5" width="8" height="14" rx="1"/><path d="m5 16 2-3 2 3m6 0 2-3 2 3"/>
    </g>
    <g v-else-if="id === 'image-splitter'">
      <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 3v18M3 12h18"/><path d="m9 6-2 2m8-2 2 2m-8 8-2-2m8 2 2-2"/>
    </g>
    <g v-else-if="id === 'collage-maker'">
      <rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 3v18M12 12h9"/><path d="m5 18 3-4 2 2m4 2 2-3 3 3"/>
    </g>
    <g v-else-if="id === 'chart-maker'">
      <path d="M4 20V4M4 20h16"/><rect x="7" y="12" width="3" height="5" rx=".5"/><rect x="12" y="8" width="3" height="9" rx=".5"/><rect x="17" y="5" width="3" height="12" rx=".5"/>
    </g>
    <g v-else-if="id === 'face-blur'">
      <circle cx="12" cy="10" r="5"/><path d="M4 21c1-4 4-6 8-6s7 2 8 6M8 9h.01M16 9h.01M9 12c2 1 4 1 6 0"/><path d="M3 6V3h3M18 3h3v3M3 18v3h3M21 18v3h-3"/>
    </g>
    <g v-else-if="id === 'background-blur'"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M7 18c1-3 3-4 5-4s4 1 5 4M5 7h.01M19 8h.01M6 12h.01M18 14h.01"/></g>
    <g v-else-if="id === 'colorize-photo'"><circle cx="12" cy="12" r="8.5"/><path d="M12 3.5v17M12 7c3 0 5 2 5 5s-2 5-5 5"/><path d="M7 8h.01M8 12h.01M7 16h.01"/></g>
    <g v-else-if="id === 'text-tools'"><path d="M4 6h16M9 6v12M6 18h6"/><path d="M15 11h5M15 15h5M15 19h3"/></g>
    <g v-else-if="id === 'qr-generator'"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M15 14h2v2h-2zM19 14h2v4h-2M14 19h4v2h-4M20 20h1"/></g>
    <g v-else-if="id === 'qr-scanner'"><path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"/><rect x="7" y="7" width="4" height="4"/><path d="M15 7h2v2h-2M15 12h3v3h-3M8 15h3v3H8"/></g>
    <g v-else-if="id === 'barcode-generator'"><path d="M4 5v14M7 5v14M10 5v14M14 5v14M16 5v14M20 5v14"/><path d="M2 21h20"/></g>
    <g v-else-if="id === 'barcode-scanner'"><path d="M7 4H3v4M17 4h4v4M3 16v4h4M21 16v4h-4"/><path d="M7 8v8M10 8v8M13 8v8M17 8v8"/></g>
    <g v-else-if="id === 'seo-meta-tool'"><path d="M4 5h11M4 9h8M4 13h6"/><circle cx="15" cy="15" r="5"/><path d="m19 19 2 2M13 15h4M15 13v4"/></g>
    <g v-else-if="id === 'social-meta-tool'"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="m5 16 4-4 3 3 2-2 5 4"/><circle cx="16" cy="8" r="1.5"/><path d="M8 7h4"/></g>
    <g v-else-if="id === 'heading-checker'"><path d="M4 5v6M8 5v6M4 8h4M12 6h8M12 11h6M7 15h13M10 20h10"/><path d="m3 17 2-2 2 2"/></g>
    <g v-else-if="id === 'image-metadata-tool'"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="m5.5 16 4-4 3 3 2-2 4 4"/><circle cx="16" cy="8" r="1.5"/><path d="M7 7h4M7 9h3M15 18h4"/></g>
    <g v-else-if="id === 'robots-tool'"><rect x="5" y="7" width="14" height="12" rx="2"/><path d="M12 3v4M9 12h.01M15 12h.01M8 16h8M3 11v4M21 11v4"/></g>
    <g v-else-if="id === 'sitemap-validator'"><path d="M12 4v5M6 20v-4h12v4M6 16v-3h12v3M12 9v4"/><rect x="9" y="2" width="6" height="4" rx="1"/><rect x="3" y="19" width="6" height="3" rx="1"/><rect x="15" y="19" width="6" height="3" rx="1"/></g>
    <g v-else-if="id === 'canonical-hreflang'"><path d="M9 15 7 17a3 3 0 0 1-4-4l3-3a3 3 0 0 1 4 0M15 9l2-2a3 3 0 0 1 4 4l-3 3a3 3 0 0 1-4 0M8 12h8"/></g>
    <g v-else-if="id === 'schema-generator'"><path d="M5 4H3v16h2M19 4h2v16h-2M8 8h8M8 12h6M8 16h8"/></g>
    <g v-else-if="id === 'color-picker'">
      <path d="m14.5 5.5 4 4M7 17l8.8-8.8a2.8 2.8 0 1 0-4-4L3 13v4h4Z"/><path d="M3 21h7"/>
    </g>
    <g v-else-if="id === 'image-editor'">
      <rect x="3" y="4" width="18" height="14" rx="2"/><path d="m5.5 15 4-4 3 3 2-2 4 4M16 7h2M17 6v2"/><path d="M8 21h8"/>
    </g>
    <g v-else-if="id === 'format-converter'">
      <path d="M7 7h11l-3-3M18 7l-3 3M17 17H6l3 3M6 17l3-3"/><rect x="3" y="3" width="4" height="4" rx="1"/><rect x="17" y="17" width="4" height="4" rx="1"/>
    </g>
    <g v-else-if="id === 'gif-maker'">
      <rect x="5" y="4" width="14" height="14" rx="2"/><path d="M8 2h8M8 20h8"/><path d="m10 8 5 3-5 3V8Z"/>
    </g>
    <g v-else-if="id === 'color-changer'">
      <path d="M4 8h12l-3-3M16 8l-3 3M20 16H8l3-3M8 16l3 3"/><circle cx="5" cy="16" r="2"/><circle cx="19" cy="8" r="2"/>
    </g>
    <g v-else-if="id === 'wireframe'">
      <rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 8h18M8 8v12M11 11h7M11 15h4"/><circle cx="6" cy="6" r=".5" fill="currentColor" stroke="none"/>
    </g>
    <g v-else-if="id === 'booking-loss'">
      <rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 7h8M8 11h2M14 11h2M8 15h2M14 15h2"/><path d="m8 19 8-8M15.5 18.5h.01M8.5 11.5h.01"/>
    </g>
    <g v-else-if="id === 'app-roi-calculator'">
      <rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M10 6h4M10 18h4"/><path d="m9.5 14 2.2-2.4 1.7 1.5 2-3"/><path d="m14.2 10.1 1.4-.1-.1 1.4"/>
    </g>
    <g v-else data-icon-fallback="true">
      <rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="9" r="1.5"/><path d="m5.5 17 4.5-4 3 2.5 2-2 3.5 3.5"/>
    </g>
  </svg>
</template>

<script>
export const TOOL_ICON_IDS = [
  'background-remover', 'image-compressor', 'flip-image', 'rotate-image',
  'black-white-image', 'pixelate-image', 'round-image', 'border-image',
  'text-image', 'crop-image', 'watermark-image', 'combine-images', 'image-splitter', 'collage-maker', 'chart-maker', 'face-blur', 'background-blur', 'colorize-photo', 'color-picker', 'image-editor', 'format-converter',
  'gif-maker', 'color-changer', 'wireframe', 'booking-loss', 'app-roi-calculator', 'text-tools',
  'qr-generator', 'qr-scanner', 'barcode-generator', 'barcode-scanner', 'seo-meta-tool', 'social-meta-tool', 'heading-checker', 'image-metadata-tool', 'robots-tool', 'sitemap-validator', 'canonical-hreflang', 'schema-generator'
]

export default {
  name: 'ToolIcon',
  props: { id: { type: String, required: true } }
}
</script>

<style scoped>
.tool-svg { display: block; width: 28px; height: 28px; }
</style>
